import { gql } from '@apollo/client';

const video = `
  _id
  name
  videoId
`

export const CREATE_VIDEO = gql`
  mutation VideoCreateOne($record: CreateVideoInput!) {
    video: VideoCreateOne(record: $record) {
      ${video}
    }
  }
`

export const GET_VIDEO = gql`
query VideoById($id: ObjectId!) {
  video: VideoById(_id: $id) {
    _id
    status
    thumbnailUrl
    createdAt
  }
}
`
